"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RecaptchaField;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));
// this key is publicly distributed by Google for testing purposes only
const fallbackSiteKey = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
function RecaptchaField({
  dataCy,
  sitekey = fallbackSiteKey,
  onChange,
  onError,
  onExpired
}) {
  return /*#__PURE__*/_react.default.createElement(_reactGoogleRecaptcha.default, {
    sitekey: sitekey,
    onChange: onChange,
    onError: onError,
    onExpired: onExpired,
    "data-cy": dataCy
  });
}
RecaptchaField.propTypes = {
  dataCy: _propTypes.default.string,
  sitekey: _propTypes.default.string,
  onError: _propTypes.default.func,
  onExpired: _propTypes.default.func,
  onChange: _propTypes.default.func
};